import type { AnnouncementEventType } from '@api';
import dayjs from 'dayjs';

export const getAnnouncementTimeLabel = (
  announcement: AnnouncementEventType
): string | null => {
  if (!announcement.startTime) {
    return null;
  }

  const start = dayjs(`1970-01-01T${announcement.startTime}`);

  if (!start.isValid()) {
    return null;
  }

  const formattedStart = start.format('HH:mm');

  if (announcement.duration !== null) {
    return `${formattedStart} - ${start.add(announcement.duration, 'hour').format('HH:mm')}`;
  }

  return formattedStart;
};
